import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import * as api from "api/api";
import { SearchCitiesResource } from "api/resource/search-cities";
import { loginReset } from "redux/slice/authentication";

export interface SearchCitiesState {
    loading?: boolean;
    error?: string | null;
    searchCities?: SearchCitiesResource;
}

const initialState: SearchCitiesState = {
    loading: false,
};

export const fetchSearchCities = createAsyncThunk("searchCities/fetch", async (_, thunkAPI) => {
    thunkAPI.dispatch(searchCitiesLoading());
    const result = api.getSearchCities();
    result
        .then((s) => thunkAPI.dispatch(searchCitiesLoaded(s)))
        .catch((e) => thunkAPI.dispatch(searchCitiesFailed(e)));
    return result;
});

export const saveSearchCities = createAsyncThunk("searchCities/save", async (payload: SearchCitiesResource, thunkAPI) => {
    thunkAPI.dispatch(searchCitiesLoading());
    const result = api.updateSearchCities(payload);
    result
        .then((s) => thunkAPI.dispatch(searchCitiesLoaded(s)))
        .catch((e) => thunkAPI.dispatch(searchCitiesFailed(e)));
    return result;
});

export const searchCitiesSlice = createSlice({
    name: "searchCities",
    initialState,
    reducers: {
        searchCitiesLoading: (state) => {
            state.loading = true;
        },
        searchCitiesLoaded: (state, action: PayloadAction<SearchCitiesResource>) => {
            state.loading = false;
            state.error = null;
            state.searchCities = action.payload;
        },
        searchCitiesFailed: (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.error = action.payload.message;
        },
        default: (state) => {
            return state;
        },
    },
    extraReducers(builder) {
        builder.addCase(loginReset, () => {
            return initialState;
        });
    },
});

export const { searchCitiesLoading, searchCitiesLoaded, searchCitiesFailed } = searchCitiesSlice.actions;
